import api from "../api/axios";
import { useNextStep } from "../contexts/NextStepContext";
import BetaInvite from "./BetaInvite";

/**
 * The screen an activity ends with, when its ending is a screen rather than a transition.
 */
const JourneyEnding = () => {
    const { ending, resolveEnding } = useNextStep();

    const handleDismissed = async () => {
        try {
            // Must be awaited: resolveEnding() re-reads the completion control, which
            // still says "beta-invite" until the decline is persisted.
            await api.post("/accounts/decline-beta-prompt/");
        } catch (err) {
            console.error("Failed to retire the beta prompt:", err);
        }
        resolveEnding();
    };

    return (
        <BetaInvite
            open={ending === "beta-invite"}
            join={() => api.post("/accounts/join-beta/")}
            onJoined={resolveEnding}
            onDismissed={handleDismissed}
        />
    );
};

export default JourneyEnding;
